























import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import {GetDicDicts,SavePatientTags} from '../../../api/dialysisProcess'

import {GetListByCode} from '../../../api/configureDictionary/'


@Component({
    components:{}
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;

    //数据源
    tagList:any = []
    selectTags:any = []
    async created() {
        await this.getData()
        this.selectTags = this.data.tag?this.data.tag.split(';'):[]
        this.tagList.forEach((item:any) => {
            item.checked = false
            this.selectTags.forEach((element:any) => {
                if(item.itemName == element){
                    item.checked = true
                }
            });
        });
    }
    tagChange(checked:any,name:any){
        console.log(checked,name)
        if(checked){
            this.selectTags.push(name)
        }else{
            this.selectTags.forEach((item:any,index:any) => {
                if(item==name){
                    this.selectTags.splice(index,1)
                }
            });
        }
    }
    
    async save(){
        let data = {
            patientId:this.data.patientId,
            tag:this.selectTags.join(';')
        }
        let res = await SavePatientTags(data)
        if(res.status == 1){
            this.$emit('on-back')
            this.$emit('input',false);
        }
    }
    async getData(){
        let res = await GetDicDicts({PItemCode:'tag'})
        this.tagList = res.objects
        console.log(res)
    }
    cancel(){
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/tagManage.vue